import { useQuery } from "@tanstack/react-query";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string} deps.resourceType - "DATASET_OFFERING" | "VOCABULARY"
 * @param {string} deps.authority
 * @param {Record<string, string>} deps.requestHeaders
 * @param {{pageIndex:number,pageSize:number}} deps.pagination
 * @param {boolean} deps.enabled
 */
export function useObservabilityStatistics({
  callApiWithWorker,
  resourceType,
  authority,
  requestHeaders,
  pagination,
  enabled = true,
}) {
  const requestHeadersKey = JSON.stringify(requestHeaders ?? {});

  return useQuery({
    queryKey: [
      "observability",
      "statistics",
      resourceType,
      authority ?? "",
      requestHeadersKey,
      pagination?.pageIndex ?? 0,
      pagination?.pageSize ?? 10,
    ],
    enabled: Boolean(enabled && resourceType),
    keepPreviousData: true,
    queryFn: async () => {
      const endpoint =
        `api/observability/statistics` +
        `?page=${pagination.pageIndex}&size=${pagination.pageSize}`;

      const resp = await callApiWithWorker(endpoint, {
        method: "GET",
        headers: {
          "Resource-Type": resourceType,
          ...(authority !== undefined ? { authority: authority ?? "" } : {}),
          ...(requestHeaders ?? {}),
        },
      });

      return resp?.result ?? [];
    },
  });
}
